export const FARE_RULE_TABLE_ITEM_LABEL = {
  ADULT: 'label.adult',
  FARE_NAME: 'label.fareName',
  APPLID_RULE: 'label.applidRule',
  YOUNG_ADULT: 'label.youngAdult',
  CHILD: 'label.child',
  INFANT: 'label.infant',
  INS: 'label.ins',
  AWARDTYPE_NH: 'label.awardType.nh',
  AWARDTYPE_STAR: 'label.awardType.star',
  AWARDTYPE_NONSTAR: 'label.awardType.nonStar',
  ITINERARY_FARE_RULES_DETAIL: 'reader.itineraryFareRulesDetail',
  FARE_RULE_DETAIL: 'label.fareRulesDetail',
  AWARD_FARE_STAR: 'label.awardFare.star',
  HYPHEN: 'label.hyphen',
  APPLID_PROMOTION: 'label.applidPromotion',
  AWARD_FARE_NONSTAR: 'label.awardFare.nonStar',
  PARTNER_AIRLINE_BENEFITS: 'label.partnerAirlineBenefits',
  DOMESTIC_AWARD: 'label.awardFare.domestic',
  FARE_RULES_DETAIL_AWARD_TYPE: 'label.fareRulesDetailawardType.nh',
  NONE: '',
};

export const FARE_RULES_LABEL = {
  FARE_RULE: 'label.fareRule',
  APPLID_RULE: 'label.applidRule',
  AWARD_KIND: 'heading.awardKind',
  FARE_RULE_DETAIL: 'label.fareRulesDetail',
  AWARD_FARE_NH: 'label.awardFare.nh',
  AWARD_FARE_STAR: 'label.awardFare.star',
  AWARD_FARE_NONSTAR: 'label.awardFare.nonStar',
  STAY_PERIOD_DAYS: 'label.stayPeriodDays',
  DOMESTIC_AWARD: 'label.awardFare.domestic',
  // 提携: 特典時の運賃ルールに「運賃ルール詳細をご確認ください」の旨を表示する
  AWARD_RULE: 'label.awardRule',
  NONE: '',
};

export const PAYMENT_DETAILS = {
  ITINERARY_AMOUNT_DUE: 'label.itineraryAmountDue',
  PAYMENT_TOTAL_AMOUNT_NOT_PURCHASED: 'label.paymentTotalAmountNotPurchased',
  ANCILLARY_SERVICE_AMOUNT: 'label.ancillaryServiceAmount',
  PAYMENT_PAID_SERVICES: 'label.paymentPaidServices',
  PAYMENT_TOTAL_AMOUNT: 'label.paymentTotalAmount',
  MILE_UNIT: 'label.mileUnit',
  OTHERS_TAX: 'label.othersTax',
  EXTEMPTED: 'label.exempted',
  COUCH: 'label.couch',
  NONE: 'label.none',
};

export const PASSENGER_TYPE_LABEL = {
  ADULT: 'label.adult',
  YOUNG_ADULT: 'label.youngAdult',
  CHILD: 'label.child',
  INFANT: 'label.infant',
  INS: 'label.ins',
};

export const PROMOTION_LABEL = {
  INTER_AIRPORT_TRANSIT: 'label.interAirportTransit',
  TRANSIT_IN_AIRPORT: 'label.transitInAirport',
};

export const POS_COUNTRY_CODE = {
  CA: 'CA',
  MY: 'MY',
  KR: 'KR',
};

export const ITINERARY_TYPE = {
  ROUNDTRIP: 'roundtrip',
  ONEWAYORMULTICITY: 'onewayOrMulticity',
};

export const CABIN_CLASS = {
  ECO: 'eco',
  ECO_PREMIUM: 'ecoPremium',
  BUSINESS: 'business',
  FIRST: 'first',
};

export const AMC_ENDPOINT_ID = {
  JA: '/ja/jp/amc/signup/',
  ZH: '/zh/jp/amc/signup/',
  EN: '/en/jp/amc/signup/',
  IT: '/it/it/amc/signup/',
};

export const STAY_PERIOD = {
  MAX: 'maximumStays',
  MIN: 'minimumStays',
};
